<template>
  <!-- Main Content -->
  <div class="page-wrapper">
    <div class="container-fluid">

      <!-- Title -->
      <div class="row heading-bg">
        <div class="col-lg-4 col-md-4 col-sm-4 col-xs-12">
          <h5 class="txt-dark">
            <back-button link="/settings/pf-configurations"></back-button> 
            Update PF Configurations
          </h5>
        </div>
        <!-- Breadcrumb -->
        <div class="col-lg-8 col-sm-8 col-md-8 col-xs-12">
          <ol class="breadcrumb">
            <li><router-link to="/">Dashboard</router-link></li>
            <li>Data Center</li>
            <li><router-link to="/settings/pf-configurations">PF Configurations</router-link></li>
            <li class="active">Create</li>
          </ol>
        </div>
        <!-- /Breadcrumb -->
      </div>
      <!-- /Title -->

      <!-- Row -->
      <div class="row">
        <div class="col-md-8">
          <div class="panel panel-default card-view">
            <div class="panel-wrapper collapse in">
              <div class="panel-body">
                <div class="row">
                  <div class="col-sm-12 col-xs-12">
                    <div class="form-wrap form-horizontal">
                      <div class="form-group">
                        <label class="col-sm-3 control-label">Effective Date</label>
                        <div class="col-sm-9">
                          <my-datepicker :date.sync="form.effective_date" placeholder="Effective Date"></my-datepicker>
                          <span class="error-block">{{ errors.effective_date }}</span>
                        </div>
                      </div>
                      <div class="form-group">
                        <label class="col-sm-3 control-label">Employer PF</label>
                        <div class="col-sm-5">
                          <input v-uppercase type="text" class="form-control" placeholder="Employer PF" v-model="form.employer_value">
                          <span class="error-block">{{ errors.employer_value }}</span>
                        </div>
                        <div class="col-sm-4">
                          <my-select :selection.sync="form.employer_type" :suggestions="configuration_types" placeholder="Employer PF Type"></my-select>
                          <span class="error-block">{{ errors.employer_type }}</span>
                        </div>
                      </div>
                      <div class="form-group">
                        <label class="col-sm-3 control-label">Employee PF</label>
                        <div class="col-sm-5">
                          <input v-uppercase type="text" class="form-control" placeholder="Employee PF" v-model="form.employee_value">
                          <span class="error-block">{{ errors.employee_value }}</span>
                        </div>
                        <div class="col-sm-4">
                          <my-select :selection.sync="form.employee_type" :suggestions="configuration_types" placeholder="Employee PF Type"></my-select>
                          <span class="error-block">{{ errors.employee_type }}</span>
                        </div>
                      </div>
                      <!-- <div class="form-group">
                        <label class="col-sm-3 control-label">Min Wage</label>
                        <div class="col-sm-9">
                          <input v-uppercase type="number" class="form-control" placeholder="Min Wage" v-model="form.min_wage">
                          <span class="error-block">{{ errors.min_wage }}</span>
                        </div>
                      </div> -->
                      <div class="form-group">
                        <label class="col-sm-3 control-label">Max Wage</label>
                        <div class="col-sm-9">
                          <input v-uppercase type="number" class="form-control" placeholder="Max Wage" v-model="form.max_wage">
                          <span class="error-block">{{ errors.max_wage }}</span>
                        </div>
                      </div>
                      <div class="form-group">
                        <label class="col-sm-3 control-label">EPF Contribution</label>
                        <div class="col-sm-5">
                          <input v-uppercase type="text" class="form-control" placeholder="Employer EPF Contribution (%)" v-model="form.employer_epf">
                        </div>
                        <div class="col-sm-4">
                          <input v-uppercase type="text" class="form-control" placeholder="Employee EPF Contribution (%)" v-model="form.emplooyee_epf">
                        </div>
                      </div>
                      <div class="form-group">
                        <label class="col-sm-3 control-label">EPS Contribution</label>
                        <div class="col-sm-5">
                          <input v-uppercase type="text" class="form-control" placeholder="Employer EPS Contribution (%)" v-model="form.employer_eps">
                        </div>
                        <div class="col-sm-4">
                          <input v-uppercase type="text" class="form-control" placeholder="Employee EPS Contribution (%)" v-model="form.employee_eps">
                        </div>
                      </div>
                      <div class="form-group">
                        <label class="col-sm-3 control-label">EDLIS Contribution</label>
                        <div class="col-sm-5">
                          <input v-uppercase type="text" class="form-control" placeholder="Employer EDLIS Contribution (%)" v-model="form.employer_edlis">
                        </div>
                        <div class="col-sm-4">
                          <input v-uppercase type="text" class="form-control" placeholder="Employee EDLIS Contribution (%)" v-model="form.employee_edlis">
                        </div>
                      </div>
                      <div class="form-group">
                        <label class="col-sm-3 control-label">EPF Administrative Charges</label>
                        <div class="col-sm-5">
                          <input v-uppercase type="text" class="form-control" placeholder="Employer EPF Administrative Charges (%)" v-model="form.employer_epf_admin">
                        </div>
                        <div class="col-sm-4">
                          <input v-uppercase type="text" class="form-control" placeholder="Employee EPF Administrative Charges (%)" v-model="form.employee_epf_admin">
                        </div>
                      </div>
                      <div class="form-group">
                        <label class="col-sm-3 control-label">EDLIS Administrative Charges</label>
                        <div class="col-sm-5">
                          <input v-uppercase type="text" class="form-control" placeholder="Employer EDLIS Administrative Charges (%)" v-model="form.employer_edlis_admin">
                        </div>
                        <div class="col-sm-4">
                          <input v-uppercase type="text" class="form-control" placeholder="Employee EDLIS Administrative Charges (%)" v-model="form.employee_edlis_admin">
                        </div>
                      </div>
                      <div class="form-group">
                        <label class="col-sm-3 control-label">Applicable On</label>
                        <div class="col-sm-9">
                          <my-select :selection.sync="form.applicable_on" :suggestions="applicables" placeholder="Applicable On"></my-select>
                          <span class="error-block">{{ errors.applicable_on }}</span>
                        </div>
                      </div>
                      <div class="form-group mb-0">
                        <div class="col-sm-offset-3 col-sm-9">
                          <submit-button :isLoading="isLoading" @submit="save" text="Update"></submit-button>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>  
        </div>
      </div>
      <!-- /Row -->
    </div>

  </div>
  <!-- /Main Content -->
</template>

<script type="text/javascript">
import axios from 'axios'

export default {
  name: 'ptConfigurationEdit',
  data () {
    return {
      form: {
        effective_date: new Date(),
        employer_value: 0,
        employer_type: 2,
        employee_value: 0,
        employee_type: 2,
        applicable_on: 1,
      },
      configuration_types: [
        {id: 1, name: 'Flat',},
        {id: 2, name: '%',},
      ],
      isLoading: false,
      applicables: [
        {id: 1, name: 'On Gross'},
        {id: 2, name: 'On Basic and DA'}
      ],
    }
  },
  mounted() {
    this.form.site_id = this.site.id
    this.getData()
  },
  methods: {
    async getData() {
      this.isLoading = true
      let form = await axios.get(`/pf_configurations/${this.$route.params.pfConfigurationId}`)
      this.form = form.data.data
      this.form.applicable_on = this.form.applicable_on || ''
      this.isLoading = false
    },
    async save() {
      try {
        this.isLoading = true
        await axios.patch(`/pf_configurations/${this.$route.params.pfConfigurationId}`, this.form)
        this.isLoading = false
        this.$router.push('/settings/pf-configurations')
      } catch(e) {
        this.isLoading = false
      }
    }
  }
}
</script>